import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { DesignChangeRepository } from '@efficiently/client-api-design-changes';

import { DesignChangeGqlRepository } from './repositories/design-change-gql.repository';

export function provideDesignChangesDataAccess(): EnvironmentProviders {
	return makeEnvironmentProviders([{ provide: DesignChangeRepository, useClass: DesignChangeGqlRepository }]);
}
